import type { BoxInfo, CardInfo } from '@lub0v/santa-utils';

export function drawNeedsAttention(info: BoxInfo, cards: CardInfo[]): boolean {
  return Boolean(info.isActiveDraw && !info.box.isArchived && cards.some(card => !card.wardId));
}
